// extracted by mini-css-extract-plugin
export default {"containerDivStyle":"MediaModal_containerDivStyle__4Y2Xq","imageStyle":"MediaModal_imageStyle__QeKaM","responsiveIframeStyle":"MediaModal_responsiveIframeStyle__NliTN"};